// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media(max-width: 1024px) {\n.mdc-button {\n    margin-bottom: 3rem;\n}\n}\n", ""]);
// Exports
module.exports = exports;
